import { CuboidCollider, RigidBody } from "@react-three/rapier";

export default function ShapeWalls({aY, height})
{
    // console.log(a)
    // const aY = 6
    height -= 1.5
    const pY = aY + height

    return <>
    
    <RigidBody type='fixed' friction={0.7} >
        <CuboidCollider args={[5, aY, 0.25]} position={[0, pY, -5.25]} />
        <CuboidCollider args={[5, aY, 0.25]} position={[0, pY, 5.25]} />
        <CuboidCollider args={[0.25, aY, 5.5]} position={[-5.25, pY, 0]} />
        <CuboidCollider args={[0.25, aY, 5.5]} position={[5.25, pY, 0]} />
    </RigidBody>

    </>
}